var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cz2__panel cz2__panel--secondary cz2__panel--secondary-fullscreen"},[_c('focus-lock',{attrs:{"disabled":_vm.focusLockDisabled}},[_c('div',{staticClass:"cz2__panel__header"},[_c('details-header')],1),_c('div',{class:[
            'cz2__panel__body',
            'cz2__panel__body--with-html',
            {
                'cz2__panel__body--hack': _vm.panelBodyHack
            }
        ]},[_c('panel-header',{attrs:{"title":_vm.title,"align":_vm.isFullHeight ? 'left' : 'center'}}),_vm._t("default")],2),_vm._t("actions")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }